<template>
    <div class="header__cart" v-if="!isCheckoutPage">
        <a :href="checkoutRoute" aria-haspopup="true">
            <span class="fas fa-shopping-bag"></span>
            <span>{{ cartTotalProducts }}</span>
            <span class="sr-only">Cart</span>
        </a>

        <div class="minicart">
            <div class="inner" v-if="isHasProducts">
                <div class="list">
                    <div class="list__inner">
                        <div class="item" v-for="product in products">
                            <div class="item__thumb">
                                <a :href="product.permalink"><img :src="product.options.image_url" :alt="product.name"></a>
                            </div>
                            <div class="item__meta">
                                <div class="title">
                                    <a :href="product.permalink">{{ product.name }}</a>
                                </div>
                                <div class="options">
                                    <ul v-if="product.options.product_options">
                                        <li v-for="option in product.options.product_options">
                                            <strong>{{ option.name }}:</strong> {{ option.value }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="data">
                                    <div class="qty">
                                        <span><strong>Quantity:</strong> {{ product.qty }}</span>
                                    </div>
                                    <div class="price">
                                        <span>${{ product.price }}</span>
                                    </div>
                                </div>
                                <a href="javascript:;" @click.prevent="remove(product.rowId)" class="remove">Remove</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <a :href="checkoutRoute">View Cart</a>
                    <span><strong>Total:</strong> ${{ total }}</span>
                </div>
                <a :href="checkoutRoute" class="btn-default">Checkout</a>
            </div>
            <div class="inner" v-else>
                <div class="list empty">
                    <div class="item">
                        <div class="item__meta">
                            <div class="title">
                                Cart Empty
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <a :href="catalogRoute" class="btn-default">Shop Now</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex';
    import {isObject} from "lodash";

    export default {
        props: {
            checkoutRoute: {
                required: true,
                type: String,
            },
            catalogRoute: {
                required: true,
                type: String,
            }
        },
        data: () => ({
            isCartLoaded: false,
        }),
        mounted: function () {
            this.loadCart();
        },
        computed: {
            products: {
                get() {
                    return this.$store.state.cart.data.products
                },
                set(p) {
                    this.$store.commit('cart/setProducts', p)
                }
            },
            total: {
                get() {
                    return this.$store.state.cart.data.total;
                },
                set(p) {
                    this.$store.commit('cart/setTotal', p)
                }
            },
            cartTotalProducts: function () {
                return Object.values(this.products).reduce((t, {qty}) => t + qty, 0);
            },
            isHasProducts: function () {
                return !!(isObject(this.products) ? Object.keys(this.products).length : false);
            },
            isCheckoutPage: function () {
                return this.$route.path !== '/' && this.checkoutRoute.includes(this.$route.path);
            }
        },
        methods: {
            ...mapMutations([
                'setData'
            ]),
            loadCart: function () {
                this.isCartLoaded = false;
                axios.get('/api/v1/cart/small')
                    .then((response) => {
                        this.products = response.data.products;
                        this.total = response.data.total;
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .then(() => {
                        this.isCartLoaded = true;
                    });
            },
            remove: function (index) {
                axios.delete(`/api/v1/cart/items/${index}`)
                    .then((r) => {
                        const removedProduct = this.products.find(product => product.rowId === index);

                        if (undefined !== removedProduct) {
                            this.onProductRemovedFromCart(removedProduct.title);
                        }

                        this.products = r.data.products;
                        this.total = r.data.total;
                    })
                    .catch((error) => {

                    });
            },
        }
    };
</script>
